import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NbToastrService, NbSidebarService } from '@nebular/theme';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MasterService } from '../../@core/services/master.service';
import { RoleService } from '../../@core/services/role.service';
import { ProjectService } from '../../@core/services/project.service';
import { AbstractControl, ValidatorFn } from '@angular/forms';

// Custom validator to check at least one checkbox selected
function atLeastOneCheckboxCheckedValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    const group = control.value;
    const atLeastOneSelected = Object.values(group).some(val => val === true);
    return atLeastOneSelected ? null : { required: true };
  };
}

@Component({
  selector: 'ngx-part-alert',
  templateUrl: './part-alert.component.html',
  styleUrls: ['./part-alert.component.scss']
})
export class PartAlertComponent implements OnInit {
  form!: FormGroup;
  partForm: FormGroup;
  userRole: any;
  modalRef: NgbModalRef | null = null;
  modalDeleteRef: NgbModalRef | null = null;
  // partsDetails = [];
  partsDetails: any = [];
  // frequencyOptions: string[] = [];
  frequencyOptions: { id: number, scheduleType: string }[] = [];

  filteredPartsDetails: any[] = []; // displayed data
  isRefresh = false;

  showSearchRow: boolean[] = [];
  searchValues: string[] = [];
  showSearch: boolean = true;
  deletePartId: any;
  deletePartDetailsIndex!: number;
  deletePartJobId: string = '';
  showModal: boolean = false;
  selectedPart: any = null;
  selectedProjectName: string = '';
  // projectNameDetails: string[] = [];
  projectNameDetails: any[] = [];
  availableVersions: number[] = [];

  closeResult: string = '';

  projectViewData: any;
  // deletePartDetailsIndex: any = '';
  constructor(private f_builder: FormBuilder,
    private sidebarService: NbSidebarService,
    private router: Router,
    private modalService: NgbModal,
    private masterService: MasterService,
    private roleService: RoleService,
    private notify: NbToastrService,
    private projectService: ProjectService) {

    // Initialize the form group with validation
    this.partForm = this.f_builder.group({
      internalPartNo: ['', Validators.required],
      projectName: ['', Validators.required],
      project_id: [null],
      version_id: ['', Validators.required],
      MPN: ['', Validators.required],
      manufacturer: ['', Validators.required],
      uom: ['', Validators.required],
      requiredQuantity: ['', [Validators.required, Validators.min(1)]],
      // frequency: ['', Validators.required],
      frequency: [null, Validators.required],
    });

  }
  tableHeaders = [
    { key: 'internal_part_no', label: 'Internal Part No.' },
    { key: 'project_name', label: 'Project Name' },
    { key: 'version_id', label: 'Version Id' },
    { key: 'mpn', label: 'MPN' },
    { key: 'manufacturer', label: 'Make' },
    { key: 'uom', label: 'UOM' },
    { key: 'project_qty', label: 'Required Quantity' },
    { key: 'frequency_id', label: 'Frequency' },
    { key: 'sourcing_type', label: 'Source Type' },
    { key: 'created_at', label: 'Created Date' },
    { key: 'status', label: 'Status' },
  ];
  ngOnInit() {
    this.userRole = this.roleService.getUserRole();
    this.loadFrequencyOptions();
    this.form = this.f_builder.group({
      fromECDate: [''],
      toECDate: [''],
    })
    this.loadProjects();
    this.loadPartsAlert();
    setTimeout(() => {
      this.sidebarService.collapse('menu-sidebar');
    }, 0);
    this.showSearchRow = new Array(this.tableHeaders.length).fill(false);
    this.searchValues = new Array(this.tableHeaders.length).fill('');
  }
  loadFrequencyOptions() {
    this.masterService.get_frequency().subscribe({
      next: (res) => {
        if (Array.isArray(res)) {
          this.frequencyOptions = res;
        }
      },
      error: (err) => {
        console.error("Error loading frequency options", err);
      }
    });
  }



  loadProjects() {
    this.projectService.getAllProjects().subscribe({
      next: (res: any) => {
        console.log("Projects API response:", res);

        if (res && res.status === "success" && res.data?.length) {
          // Group flat list by project_id and collect all version_ids
          const groupMap = new Map<number, any>();
          res.data.forEach((item: any) => {
            const pid = item.project_id;
            if (!groupMap.has(pid)) {
              groupMap.set(pid, {
                ...item,
                projectName: item.project_name || item.projectName,
                version_ids: []
              });
            }
            const vid = item.version_id;
            if (vid && !groupMap.get(pid).version_ids.includes(vid)) {
              groupMap.get(pid).version_ids.push(vid);
            }
          });
          this.projectNameDetails = Array.from(groupMap.values());
          console.log("Grouped projectNameDetails:", this.projectNameDetails);
        } else {
          this.notify.danger("No projects found.");
        }
      },
      error: (err) => {
        console.error("API error:", err);
        this.notify.danger("Something went wrong while fetching projects.");
      }
    });
  }


  onSelectProject() {
    const selectedProjectName = this.partForm.get('projectName')?.value;
    const selectedProject = this.projectNameDetails.find(
      (p: any) => p.projectName === selectedProjectName
    );

    if (selectedProject) {
      this.availableVersions = [...selectedProject.version_ids].sort((a, b) => a - b);
      this.partForm.patchValue({
        project_id: selectedProject.project_id,
        version_id: ''  // reset version id
      });
    }
  }
  onSelectVersion() {
    const projectId = this.partForm.get('project_id')?.value;
    const versionId = this.partForm.get('version_id')?.value;

    if (projectId && versionId) {
      this.masterService.get_Projectview_part(projectId, versionId).subscribe({
        next: (res: any) => {
          console.log("get_project_view response =>", res);

          if (res?.message === 'Success' && res.results?.length > 0) {
            const projectData = res.results[0];
            // Extract parts from the API response
            this.internalPartList = projectData.parts || [];
          } else {
            this.internalPartList = [];
            this.notify.danger('No parts found for selected project/version.');
          }
        },
        error: (err) => {
          console.error('Error fetching project view', err);
          this.notify.danger('Failed to load internal parts.');
          this.internalPartList = [];
        }
      });
    }
  }
  onSelectInternalPart() {
    const selectedInternalPartNo = this.partForm.get('internalPartNo')?.value;
    if (!selectedInternalPartNo) return;

    const selectedPart = this.internalPartList.find(
      (p: any) => p.internalPartNo === selectedInternalPartNo
    );

    if (selectedPart) {
      this.partForm.patchValue({
        MPN: selectedPart.MPN || '',
        manufacturer: selectedPart.manufacturer || '',
        uom: selectedPart.uom || '',
        requiredQuantity: selectedPart.projectQty || selectedPart.requiredQuantity || 0
      });
    } else {
      // clear if not found
      this.partForm.patchValue({
        MPN: '',
        manufacturer: '',
        uom: '',
        requiredQuantity: ''
      });
    }
  }

  loadPartsAlert() {
    // your logic to get data
    const currentUser: any = JSON.parse(JSON.stringify(sessionStorage.getItem('userDetails')));
    if (!currentUser) {
      console.warn('No user details found in sessionStorage.');
      return;
    }
    const payload = {
      engineer_id: currentUser?.engineer_id,
      manager_id: currentUser?.manager_id || currentUser?.user_id,
       // procurement_version_id: 0,
    };
    this.masterService.list_parts_alert(payload).subscribe(res => {
      this.partsDetails = res;
      this.filteredPartsDetails = [...this.partsDetails]; // start with all
    });
    this.onYesToDelete();
  }

  // Toggle input field visibility for a specific column
  toggleSearch(index: number) {
    this.showSearchRow[index] = !this.showSearchRow[index];
  }

  // Called from template input — explicitly sets the value first to avoid
  // the race condition where (input) fires before [(ngModel)] updates searchValues.
  onSearchChange(index: number, value: string) {
    this.searchValues[index] = value;
    this.filterData();
  }

  // Apply filter across all visible columns
  filterData() {
    this.filteredPartsDetails = this.partsDetails.filter((item: any) => {
      return this.tableHeaders.every((col, index) => {
        const searchValue = this.searchValues[index]?.toLowerCase();
        if (!searchValue) return true;

        let itemValue: string;
        if (col.key === 'frequency_id') {
          // Resolve numeric ID → label for filtering (matches what user sees)
          const label = this.getFrequencyLabel(item[col.key]);
          // Fallback to raw value if frequencyOptions isn't loaded yet or IDs don't match
          itemValue = (label || String(item[col.key] ?? '')).toLowerCase();
        } else {
          itemValue = String(item[col.key] ?? '').toLowerCase();
        }
        return itemValue.includes(searchValue);
      });
    });
  }

  home() {
    if (this.userRole === 'Engineer') {
      this.router.navigate(['/dashboard-engineer'])
    }
    else if (this.userRole === 'Manager' || this.userRole === 'Admin') {
      this.router.navigate(['/dashboard-manager'])
    }
  }
  private getDismissReason(reason: any): string {
    if (reason === 'ESC') {
      return 'by pressing ESC';
    } else if (reason === 'BACKDROP_CLICK') {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  openPartModel(projectModal: any) {
    this.modalRef = this.modalService.open(projectModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }), this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  // Add a new part to the partsDetails array
  addPart() {
    const newPart = {
      ...this.partForm.value,
      createdDate: new Date().toISOString().split('T')[0], // Current date
      lastUpdateTime: new Date().toISOString(), // Current timestamp
      status: 'Pending', // Default status
    };
    const job_id = new Date().toISOString().replace(/[-:.TZ]/g, '').slice(0, 14)
    const currentUser = JSON.parse(JSON.stringify(sessionStorage.getItem('userDetails')));
    const projectPart = this.projectViewData?.parts?.[0] || {};
    const partPayload = {
      project_id: this.partForm.value.project_id,
      project_name: newPart.projectName,
      version_id: this.partForm.value.version_id,      
      // procurement_version_id: 0,
      job_id: job_id,
      engineer_id: currentUser?.engineer_id || currentUser?.user_id,
      manager_id: currentUser?.manager_id || currentUser?.user_id,
      internal_part_no: newPart.internalPartNo,
      mpn: newPart.MPN,
      uom: newPart.uom,
      project_qty: newPart.requiredQuantity,
      frequency_id: newPart.frequency.id,
      sourcing_type: ['vendor'],
      data: [
        {
          part_header: {
            internalPartNo: newPart.internalPartNo,
            customerPartNumber: newPart.customerPartNumber || '',
            description: newPart.description || '',
            commodity: newPart.commodity || '',
            uom: newPart.uom,
            projectQty: newPart.requiredQuantity || 0,
            iSourcing: newPart.iSourcing || '',
            stockAvailability: 1,
            leadTime: 0,
            minimumPrice: 0,
            authorisedSuppliers: 0,
            suppliers: [],
            eau: 0,
          },
          Parts: [
            {
              specification: newPart.MPN || '',
              manufacturer: newPart.manufacturer ? newPart.manufacturer : "undefined"
            },
          ],
        },
      ],
    };
    this.masterService.create_part_alert(partPayload).subscribe((res: any) => {
      console.log("res => ", res)
      this.partsDetails.push(res);
      this.partForm.reset({ frequency: this.frequencyOptions[0] });
      this.notify.success('Part Added successfully', 'Success');
      this.closeModal();
      this.loadPartsAlert();

    }, (e) => {
      this.notify.success('Part Added failed', 'Error');
    })
  }

  closeModal() {
    if (this.modalRef) {
      this.modalRef.close();
    } else {
      this.modalService.dismissAll();
    }
    this.partForm.reset();
  }

  closeDeleteModal() {
    if (this.modalDeleteRef) {
      this.modalDeleteRef.close();
    } else {
      this.modalService.dismissAll();
    }
  }

  deleteModel(deletemod: any, index: number) {
    this.deletePartDetailsIndex = index;
    this.deletePartJobId = this.partsDetails[index].job_id;

    this.modalDeleteRef = this.modalService.open(deletemod, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'md',
    });

    this.modalDeleteRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  onYesToDelete() {
    if (!this.deletePartJobId) return;

    this.masterService.delete_part_alert(this.deletePartJobId).subscribe({
      next: () => {
        this.partsDetails.splice(this.deletePartDetailsIndex, 1);
        this.filteredPartsDetails = [...this.partsDetails];
        this.notify.success('Deleted successfully', 'Success');
        this.closeDeleteModal();
      },
      error: (err) => {
        console.error('Error deleting part', err);
        this.notify.danger('Failed to delete part', 'Error');
        this.closeDeleteModal();
      }
    });
  }

  get uniquePartsCount(): number {
    const uniqueSet = new Set(this.partsDetails.map((part: any) => part.internal_part_no));
    return uniqueSet.size;
  }
  get availablePartsCount(): number {
    return this.partsDetails.filter((part: any) => part.status?.toLowerCase() === 'available').length;
  }
  getFrequencyLabel(id: number): string {
    // Use Number() on both sides to handle APIs that return id as a string (e.g., '1' vs 1)
    const freq = this.frequencyOptions.find(f => Number(f.id) === Number(id));
    return freq ? freq.scheduleType : '';
  }

  viewStatusDetails(row: any) {
    // Use this.partsDetails (your full list from API)
    const relatedRecords = this.partsDetails.filter(
      (item: any) =>
        item.mpn === row.mpn && item.internal_part_no === row.internal_part_no
    );

    // Filter out duplicates if supplier values are identical
    const uniqueSuppliers: any[] = [];
    const seen = new Set<string>();

    for (const r of relatedRecords) {
      const supplierName = (r.supplier || '').toString().trim().toLowerCase();
      const totalAvail = r.TotalAvail != null ? String(r.TotalAvail).trim() : '';
      const price = r.Price != null ? String(r.Price).trim() : '';
      const currency = (r.Currency || '').toString().trim().toLowerCase();
      const spq = r.Closest_Quantity != null ? String(r.Closest_Quantity).trim() : '';
      const moq = r.MOQ != null ? String(r.MOQ).trim() : '';

      const key = `${supplierName}|${totalAvail}|${price}|${currency}|${spq}|${moq}`;

      if (!seen.has(key)) {
        seen.add(key);
        uniqueSuppliers.push({
          supplier: r.supplier,
          TotalAvail: r.TotalAvail,
          Price: r.Price,
          Currency: r.Currency,
          Closest_Quantity: r.Closest_Quantity,
          MOQ: r.MOQ,
          clickUrl: r.clickUrl
        });
      }
    }

    // Build modal data
    this.selectedPart = {
      mpn: row.mpn,
      manufacturer: row.manufacturer_best || row.manufacturer || 'N/A',
      project_name: row.project_name,
      Inventorylevel: row.Inventorylevel || 'N/A',
      supplier_availability: uniqueSuppliers
    };

    this.showModal = true;
  }
  close() {
    this.showModal = false;
  }
  internalPartList: any[] = [];


}
